<template>
	<li :class="classes" :data-commentid="note.id" :id="`note-${note.id}`">
		<div class="note__avatar">
			<img
				:src="note.author_avatar"
				:title="note.author"
			/>
		</div><!-- /.note__avatar -->

		<div class="note__content">
			<span class="note__author">{{note.author}}</span>

			<span
				:title="fullDatetimeOutput"
				class="note__date"
			>
				<i class="fa fa-calendar-o"></i> {{commentDateOutput}} ({{fromNowDateOutput}})
			</span>

			<div class="note__entry comment-entry" v-html="entry" /><!-- /.note__entry -->
		</div><!-- /.note__content -->
	</li>
</template>

<script>
import { commentDate, fromNow, fullDatetime } from '../filters';

export default {
	name: 'note',

	props: {
		note: {
			required: true,
		},
	},

	data() {
		return {
			rightNow: (new Date()).getTime()
		};
	},

	computed: {
		/**
		 * Element's classes.
		 *
		 * @return {Array}
		 */
		classes() {
			return [
				'note',
			];
		},

		/**
		 * The note entry.
		 * @return {String}
		 */
		entry() {
			return this.note.entry || this.note.comment || '';
		},

		fromNowDateOutput() {
			return fromNow(this.note.added_on, this.rightNow );
		},

		commentDateOutput() {
			return commentDate(this.note.added_on);
		},

		fullDatetimeOutput() {
			return fullDatetime(this.note.added_on)
		},
	},

	mounted() {
		this.setUpdateCurrentTimeInterval();
	},

	methods: {
		/**
		 * Set update current time interval.
		 *
		 * @return {void}
		 */
		setUpdateCurrentTimeInterval() {
			setInterval(() => {
				this.rightNow = (new Date()).getTime();
			}, 30 * 1000);
		}
	}
}
</script>
